const MIN_NUM_OF_CUSTOMERS = 100;

interface Props {
  numPeople: number;
}

export default function TotalBookings({ numPeople }: Props) {
  return numPeople > MIN_NUM_OF_CUSTOMERS ? (
    <div>
      <b style={{ fontWeight: 700 }}>{numPeople} people</b> already enjoyed this
      experience
    </div>
  ) : null;
}
